import { updateRecordAudio } from "@/services/endsize_flow";
import { DataFlowApis } from "@core/ability";
import { create } from "zustand";

interface DataFolwState {
    canClose: boolean; // 是否显示关闭按钮
    section: number; // 具体到某一个环节: 1-连接 2-类型 3-下载/上传 4-错误
    isCloud: boolean | undefined; // 是否拉取并上传到云端
    localFileSavePath: string | undefined; // 保存到本地的路径
    remoteIp: string | undefined; // 连接的大板的ip
    remotrPort: number | undefined; // 文件快传服务的可用端口
    streamName: string | undefined; // 正在上传的streamName
    waitRetryUpload: boolean; // 是否处于等待重试上传的阶段
    jsonFilePath: string | undefined; // 解析出来的json文件路径
    uploadAudioPath: string | undefined; // 正在上传的音频文件路径
    uploadProcess: number; // 上传音频进度
}

interface DataFolwStore extends DataFolwState {
    setClose: (value: boolean) => void;
    changeSection: (value: number) => void;
    setIsClound: (value: boolean) => void;
    setLocalFileSavePath: (value: string) => void;
    setIp: (value: string) => void;
    setRightPort: (value: number) => void;
    setStreamName: (value: string) => void;
    setRetryUpload: (value: boolean) => void;
    setJsonPath: (value: string) => void;
    setUploadProcess: (value: number) => void;
    setAudioPath: (value: string) => void;
    uploadAudioForStream: (statusCallback: (event: string) => void) => void;
    resetStore: () => void;
}

const dataFolwState: DataFolwState = {
    canClose: true,
    section: 1,
    isCloud: undefined,
    localFileSavePath: undefined,
    remoteIp: undefined,
    remotrPort: undefined,
    streamName: undefined,
    waitRetryUpload: false,
    jsonFilePath: undefined,
    uploadAudioPath: undefined,
    uploadProcess: 0
}

const dataFolwStore = create<DataFolwStore>()((set, get) => ({
    ...dataFolwState,
    setClose: (value) => {
        set({ canClose: value });
    },
    changeSection: (value) => {
        set({ section: value });
    },
    setIsClound: (value) => {
        set({ isCloud: value });
    },
    setLocalFileSavePath: (value) => {
        set({ localFileSavePath: value });
    },
    setIp: (value) => {
        set({ remoteIp: value });
    },
    setRightPort: (value) => {
        set({ remotrPort: value });
    },
    setStreamName: (value) => {
        set({ streamName: value });
    },
    setRetryUpload: (value: boolean) => {
        set({ waitRetryUpload: value });
    },
    setJsonPath: (value: string) => {
        set({ jsonFilePath: value });
    },
    setUploadProcess: (value) => {
        set({ uploadProcess: value });
    },
    setAudioPath: (value) => {
        set({ uploadAudioPath: value });
    },
    uploadAudioForStream: async (statusCallback: (event: string) => void) => {
        const { uploadAudioPath } = get();
        if (uploadAudioPath) {
            const processUnsubscription =
                DataFlowApis.uploadAudioProcess((data) => {
                    console.log('uploadAudioProcess', data.data.progress);
                    set({ uploadProcess: data.data.progress });
                });
            const StatusUnsubscription = DataFlowApis.uploadAudioStatus(async (data) => {
                if (data.data.event == 'success') {
                    const { streamName } = get();
                    console.log(data.data.data);
                    await updateRecordAudio(streamName!, data.data.data.fileKey);
                } else {
                    set({ section: 4 });
                    console.log('同步音频记录失败，难顶');
                }
                processUnsubscription();
                StatusUnsubscription();
                statusCallback(data.data.event);
            });
            const res = await DataFlowApis.uploadAudioFile(uploadAudioPath);
            if (!res) {
                set({ section: 4 });
                processUnsubscription();
                StatusUnsubscription();
                console.log('上传失败，改变状态');
            }
        } else {
            set({ section: 4 });
            console.log('音频路径为空，定为失败，改变状态');
        }
    },
    resetStore: () => {
        set({ ...dataFolwState });
    },
}));

export default dataFolwStore;